









































import Vue, { PropOptions } from 'vue';
import {NOC, moment} from '@/class';

import GadgetFrame, {IFrame, CFrame} from './GadgetFrame.vue';
import SampleGadgetBase from './SampleGadgetBaseV3.vue';
import BasicGadget from './EditerBasicGadgetV3.vue';
import SelectBox, {IOption} from '@/components/util/SelectBox.vue';

// 通信
import API from '@/api/common';
import * as models from '@/class/models/views/graph';
import * as dashboardModels from '@/class/models/views/dashboard';
import { IGadgetSelectOptions } from '@/class/models/views/dashboard';

const GRAPH_HW = 248;

export default Vue.extend({
  name: 'SampleGadgetV3',
  components: { SampleGadgetBase, BasicGadget },
  props: {
    title: String,
    materials: Object,
    baseFrameData: Object as PropOptions<IFrame>,
    gadgetData: Object as PropOptions<models.IGadget>,
    w: Number,
    h: Number,
    dashBoard: {
      type: Boolean,
      default: false,
    },
    plasticCase: {
      type: Boolean,
      default: false,
    },
    resized: Boolean,
    initialCt1List: Array as PropOptions<IGadgetSelectOptions[]>,
    users: Array as PropOptions<dashboardModels.IUser[]>,
    departments: Array as PropOptions<dashboardModels.IUser[]>,
    selectedBoardType: Number,
    navigation: Object as PropOptions<dashboardModels.INavigation>,
    // forceSample: Boolean, // 強制サンプル表示フラグ
  },
  data() {
    return {
      sampleFLag: true,
      defaultGadgetData: new models.CGadget(),
    };
  },
  watch: {
    defaultGadgetData: {
      deep: true,
      async handler() {
        this.defaultGadgetData.gadgetID = this.gadgetData.gadgetID;
        (this.defaultGadgetData as models.IGadget).default = true;
      },
    },
  },
  computed: {
    frameData() {
      const obj: IFrame = JSON.parse(JSON.stringify(this.baseFrameData));
      obj.sample = true;
      return obj;
    },
  },
  async mounted() {

    this.defaultGadgetData.data = {
      now: {},
      graph: this.gadgetData.data.graph,
      materials: this.gadgetData.data.materials,
      values: this.gadgetData.data.values,
      groups: [],
    };
    if (this.gadgetData.options) {
      this.defaultGadgetData.options = this.gadgetData.options;
    }
    // if (this.forceSample) {
    //   this.sampleFLag = true;
    // } else {
    let isExist = false;
    if (!this.initialCt1List) {
      const api = new API();
      const res = await api.post<models.IDomain, IOption[]>('gadget/ct1', NOC.MATERIAL.V3.MATERIALS[0]);
      isExist = res.result && res.data.length ? true : false;
    } else {
      // 初期ロード時
      const result = this.initialCt1List.find((v) => (v.materialID === NOC.MATERIAL.V3.MATERIALS[0].id));
      isExist = result && result.selectOptions.length ? true : false;
    }
    // console.log('res', res);
    if (isExist) {
    // if (res.result) {
    //  // データがある場合
    // if (res.data.length > 0) {
        // console.log(this.gadgetData);
        this.defaultGadgetData.title = this.gadgetData.title;
        this.defaultGadgetData.comment = this.gadgetData.comment;
        this.sampleFLag = false;
      // }
      // } // if (this.forceSample)の終了括弧
    }
  },
  methods: {
  },
});
